import React, { useState } from 'react';
import axios from 'axios';

const HostLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const API = process.env.REACT_APP_API_BASE_URL;
    const platformId = localStorage.getItem('platformID')

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            const response = await axios.post(`${API}/api/host/login`, { Email: email, Password: password, platformId: platformId });
            //setSuccess(`Welcome, ${response.data.Hostname}!`);
            // Store token and host info (optional)
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('HostID', response.data.hostID);
            localStorage.setItem('HostName', response.data.Hostname);
            // Redirect to the host's dashboard or home page    
            window.location.href = '/host/dashboard'; // Adjust the path as needed
        } catch (err) {
            if (err.response && err.response.status === 401) {
                setError('Invalid credentials');
            } else {
                setError('An error occurred. Please try again later.');
            }
        }
    };

     // //  Forgot Password Handler
  const handleForgotPassword = async () => {
    const email = window.prompt('Enter your registered email to receive a password reset link:');
    if (!email) return;

    try {
      const response = await axios.post(`${API}/api/host/forgot-password`, { email });
      alert('Password reset link has been sent to your registered email.');
    } catch (err) {
      alert(
        err.response?.data?.message || 'Failed to send reset link. Please try again later.'
      );
    }
  };

    return (
        <div className="container mt-5 d-flex justify-content-center">
            <div className="card shadow-sm p-4" style={{ width: '100%', maxWidth: '420px' }}>
                <h3 className="page-title text-center mb-4">Host Login</h3>

                {/* Error and success messages */}
                {error && <div className="alert alert-danger py-2">{error}</div>}
                {success && <div className="alert alert-success py-2">{success}</div>}

                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label fw-semibold">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label fw-semibold">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Login</button>
                </form>

                {/*  Forgot Password link */}
        <div className="text-center mt-3">
          <button
            className="btn btn-link text-decoration-none p-0"
            onClick={handleForgotPassword}
          >
            Forgot Password?
          </button>
        </div>
            </div>
        </div>
    );
};

export default HostLogin;
